import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {SignUpProvider} from './signup-provider';
import {ConfirmedValidator} from './confirmed.validator';
//import {SignUpRequest} from '../layout/admin/edit-profile/signin-request';
import {EditProfileProvider} from '../layout/admin/edit-profile/edit-profile-provider';
import {SignUpRequest} from './signup-request';
import {SigninRequest} from '../layout/admin/edit-profile/signin-request';
import {p} from '@angular/core/src/render3';
import {MasterBean} from '../utility/MasterBean';
import {Injector} from '@angular/core';
import {LoginRequest} from '../request/LoginRequest';
import {User} from '../utility/auth-service';

import {debounceTime} from 'rxjs/internal/operators/debounceTime';
import {tap} from 'rxjs/internal/operators/tap';
import {switchMap} from 'rxjs/internal/operators/switchMap';
import {finalize} from 'rxjs/internal/operators/finalize';
import { Decimal } from 'decimal.js';
import {Observable} from 'rxjs';
import {startWith, map} from 'rxjs/operators';
import {LazyLoadRequest} from '../request/LazyLoadRequest';
@Component({
    selector: 'app-signup-dialog',
    templateUrl: './signup-dialog.component.html',
    styleUrls: ['./signup-dialog.component.scss']
})
export class SignUpDialogComponent extends MasterBean implements OnInit {
    cityName: any;
    custName: any;
    visible: any;
    checkedRegular: boolean=false;
    checkedNonRegular: boolean=false;
    loading: boolean=false;
    stsDeactive: boolean;
    stsActive: boolean;
    GstData: any = {};
    password: String;
    c_password: String;
    email: String;
    userMobileNo: String;
  
    isLoading: boolean = false;
    form: FormGroup;
    hide: true;
    registration: SignUpRequest;
     stateNameFormControl = new FormControl();
      filteredStateName: any;
      filteredCityName: any;
    errorMsg: string;
      cityNameFormControl = new FormControl();
  // In your component class
showPasswordFields : boolean = false;// Set this to true or false based on your condition

    constructor(public router: Router, public dialogRef: MatDialogRef<SignUpDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public fb: FormBuilder,
        public provider: SignUpProvider, public injector: Injector,

    ) {
        super(injector, router, provider);
        this.registration = new SignUpRequest();
    }

    ngOnInit(): void {
        this.registration = new SignUpRequest();
//           this.initStateNameAutoComplete();
//           this.initCityNameAutoComplete();
        //      this.registration.legalName = "aaaaaa";
        //      this.registration.tradeName = "aaaaaa";
        //      this.registration.email = "aaaaaa";
        //      this.registration.userMobileNo = "aaaaaa";
        //      this.registration.password = "aaaaaa";
        //      this.registration.c_password = "aaaaaa";
        //      
        console.log("hiiiii");
        this.form = this.fb.group({
            'id': 0,
            // username: ['', Validators.required],
            // email: null,
            'bussinessName': ['', Validators.required],
           
            'signupType': ['', ],
            'userLegalName': ['', Validators.required],
            'c_password': ['', [Validators.required, Validators.minLength(6)]],
            'email': ['', [Validators.required, Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$")]],
            'userMobileNo': ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
            'password': ['', [Validators.required, Validators.minLength(6)]],
            'gstNo': [null, Validators.compose([Validators.required, Validators.pattern("^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"), Validators.minLength(15)])],
        }, {
                validator: ConfirmedValidator('password', 'c_password')
            });
    }
    
    // Use this method to update validators based on signupType
    updateValidators() {
        const gstNoControl = this.form.get('gstNo');

        if (gstNoControl) {
            if (this.form.get('signupType').value === 'NonRegular') {
                gstNoControl.clearValidators();
            } else {
                gstNoControl.setValidators([Validators.required, Validators.pattern("^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"), Validators.minLength(15)]);
            }

            gstNoControl.updateValueAndValidity();
        }
    }
    // In your component class
    togglePasswordVisibility() {
        this.showPasswordFields = !this.showPasswordFields;
    }
    handleChange(value: string, isChecked: boolean) {
        if (isChecked) {
            this.registration.manageAccount.push(value); // If checkbox is checked, add value to the array
        } else {
            const index =  this.registration.manageAccount.indexOf(value);
            if (index !== -1) {
                 this.registration.manageAccount.splice(index, 1); // If checkbox is unchecked, remove value from the array
            }
        }
        console.log( this.registration.manageAccount); // You can check the array values in the console
    }
    typeChange($event) {
        console.log($event.source.value);
        this.visible = $event.source.value;
        console.log(this.visible);
        if ($event.source.value == "Regular") {
            this.checkedRegular = true;
            this.checkedNonRegular = false;
            this.isLoading = true;
            console.log("true");

        } if ($event.source.value == "NonRegular") {
            console.log("priv");
            this.checkedNonRegular = true;
            this.checkedRegular = false;
            this.isLoading = true;
        }
        this.updateValidators();

    }
    public onSignupFormSubmit(): void {
        console.log(this.form.value);
        this.router.navigate(['/home']);
    }
    
    stateChange($event, obj) {
        console.log($event);
        if ($event.isUserInput) {
            console.log(obj);
            this.registration.state=obj.name;

        }
    }
    initStateNameAutoComplete() {
        this.stateNameFormControl.valueChanges
            .pipe(
                debounceTime(500),
                tap(() => {
                    this.errorMsg = "";
                    this.filteredStateName = [];
                    this.loading = true;
                }),
                switchMap(value => this.getCustNameAutoFilter(value)
                    .pipe(
                        finalize(() => {
                            this.loading = false
                        }),
                )))
            .subscribe(data => {
                console.log(data);
                this.filteredStateName = data;
            });
    }
    getCustNameAutoFilter(value: any) {
        console.log('********');
        console.log(value);
        var lazyCriteria = new LazyLoadRequest();
        lazyCriteria.pageSize = 100;
        lazyCriteria.filterField = "name";
        lazyCriteria.filterValue = value
        console.log(lazyCriteria);
        lazyCriteria.paramObj = {
           
        }
        return this.provider.doHttpPostLazy("/api/cust/getState", true, lazyCriteria);
    }

    stateNameChange($event) {
        console.log($event);
        this.custName = $event.option.value
        console.log(this.custName);
    }
    
     cityChange($event, obj) {
        console.log($event);
        if ($event.isUserInput) {
            console.log(obj);
            this.registration.city=obj.name;

        }
    }
    initCityNameAutoComplete() {
        this.stateNameFormControl.valueChanges
            .pipe(
                debounceTime(500),
                tap(() => {
                    this.errorMsg = "";
                    this.filteredCityName = [];
                    this.loading = true;
                }),
                switchMap(value => this.getCityNameAutoFilter(value)
                    .pipe(
                        finalize(() => {
                            this.loading = false
                        }),
                )))
            .subscribe(data => {
                console.log(data);
                this.filteredCityName = data;
            });
    }
    getCityNameAutoFilter(value: any) {
        console.log('********');
        console.log(value);
        var lazyCriteria = new LazyLoadRequest();
        lazyCriteria.pageSize = 100;
        lazyCriteria.filterField = "name";
        lazyCriteria.filterValue = value
        console.log(lazyCriteria);
        lazyCriteria.paramObj = {
           
        }
        return this.provider.doHttpPostLazy("/api/cust/getCity", true, lazyCriteria);
    }

    cityNameChange($event) {
        console.log($event);
        this.cityName = $event.option.value
        console.log(this.custName);
    }
    getGSTDetails() {
        this.isLoading = true;
        console.log(this.registration.gstNo);
        var param = {
            gstNo: this.registration.gstNo,
            key_secret: "unzQ2gK4SzgLjdEmXeNmZex8pLv1"
        }


        this.provider.dataFromGST(param).subscribe((data: any) => {
            console.log(data);
            if (data.error) {
                this.isLoading = false;
                this.util.toastError(data.message)
            } else {
                if (data.taxpayerInfo.sts == "Active") {
                    this.registration.gstNo = data.taxpayerInfo.gstin;
                    this.registration.panNo = data.taxpayerInfo.panNo;
                    this.registration.usrGstTreatment = data.taxpayerInfo.dty;
                    this.registration.bussinessName = data.taxpayerInfo.tradeNam;
                    this.registration.zipCode = data.taxpayerInfo.pradr.addr.pncd;
                    this.registration.state = data.taxpayerInfo.pradr.addr.stcd;
                    var stateCode = data.taxpayerInfo.gstin;
                    var code = stateCode.substring(0, 2);
                    this.registration.stateCode = code;
                    this.registration.userLegalName = data.taxpayerInfo.lgnm;
                    this.registration.companyAddress = data.taxpayerInfo.pradr.addr.bno + " " + data.taxpayerInfo.pradr.addr.bnm + data.taxpayerInfo.pradr.addr.flno + " " + data.taxpayerInfo.pradr.addr.dst + " " + data.taxpayerInfo.pradr.addr.pncd + " " + data.taxpayerInfo.pradr.addr.stcd;
                    this.registration.city = data.taxpayerInfo.pradr.addr.dst;
                    this.GstData = data;
                    this.isLoading = false;
                    //            this.GstData.taxpayerInfo.sts;
                    if (data.taxpayerInfo.sts == "Active") {
                        this.stsActive = true;
                    } else {
                        this.stsDeactive = false;
                    }
                } else {
                    this.isLoading = false;
                    this.stsDeactive = false;
                    this.util.toastError("GSTIN Is Inactive, Please Input Active GSTIN");
                }
            }
        })
    }

    gstInput(event) {
        console.log(this.registration.gstNo);
        var value = event.target.value.toUpperCase();
        this.registration.gstNo = value;
//        if (this.registration.gstNo == "") {
//            return
//        }
        
        if (this.registration.gstNo == null || this.registration.gstNo == "" || typeof this.registration.gstNo == "undefined")
        
        {
            this.registration.userLegalName="",
                this.registration.bussinessName =""
        }
        if (this.registration.gstNo != undefined && this.registration.gstNo != null) {
            var gstinformat = new RegExp('^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$');
            if (gstinformat.test(value)) {
                console.log("enter in iffffffffff");
                this.isLoading = true;
                this.provider.doHttpPost("/api/cust/gstNoExist", this.registration, false).subscribe((data: any) => {
                    console.log(data.message);
                    this.isLoading = false;
                    if (data.message == "NotFound") {
                        this.getGSTDetails();
                    } else {
                        this.util.toastError("Already Have an Account");
                    }
                })
            } else {
                console.log(this.registration.gstNo);
                console.log("enter in else");
                this.util.toastError("Invalid GST Number");
            }
        }







        //        if (this.registration.gstNo != undefined) {
        //
        ////            this.getGSTDetails();
        ////            this.showDetails = true;
        //        }

    }

    onSignUp() {
        console.log(this.form);
        console.log("++++++++++++++++++++++++++++===");
        console.log(this.registration);
        this.loading = this.util.showLoading();
        //        var ragister = new SignUpRequest();
        //        this.fullName = this.registration.fullName;
        //        this.tradename = this.registration.tradename;
        //        this.userMobileNo = this.registration.userMobileNo;
        //        this.email = this.registration.email;
        //        this.password = this.registration.password;
        //        this.registration.orgId = this.provider.authService.getSession().ORG_ID;
        //        this.registration.oprId = this.provider.authService.getSession().OPR_ID;
        
//        Object.keys(this.form.controls).forEach(controlName => {
//                            const control = this.form.get(controlName);
//
//                            // Check if the control is invalid
//                            if (control && control.invalid) {
//                                // Log or handle the invalid control
//                                console.log(`Invalid field: ${controlName}`);
//                            }
//                        });
        if (this.registration.gstNo == "" && this.checkedRegular){
            this.util.toastError("enter gst no")
            return;
               }
            Object.keys(this.form.controls).forEach(controlName => {
                            const control = this.form.get(controlName);

                            // Check if the control is invalid
                            if (control && control.invalid) {
                                // Log or handle the invalid control
                                console.log(`Invalid field: ${controlName}`);
                            }
                        });
                if (this.registration.userMobileNo) {
                    if (this.registration.email) {
                        if (this.registration.password) {
                            if (this.registration.c_password) {
                                if (this.registration.password === this.registration.c_password) {
                                    if (this.form.valid) {
                                        this.isLoading = true;
                                        //               this.getGSTDetails() 
                                        console.log(this.registration);
                                        this.registration.username = this.registration.email;
                                        this.provider.doRegistration(this.registration).subscribe((data: any) => {
                                            console.log(data);
                                            // Example of saving an object to localStorage
                                             this.saveObjectToLocalStorage('exampleData', data);
                                            

                                            const savedObject = this.getObjectFromLocalStorage('exampleData');
                                            console.log('Retrieved Object:', savedObject);
                                           
                                            //                    this.router.navigate(['/login']);
                                            if (data.message=="user saved successfully") {
                                            this.util.toastSuccess(" You Have Successfully Created Account ");
                                            this.dialogRef.close();
                                            this.onLoggedin(this.registration);
                                            }
                                            if (data.message=="Email is already in use") {
                                            this.util.toastSuccess(" Email is already in use");

                                            }
                                        })
                                    } else {

                                        this.util.toastError("Invalid Input Field");
                                        return;
                                    }
                                } else {
                                    this.util.toastError("Password & Confirm Password is Incorrect");
                                    return;
                                }
                            } else {
                                this.util.toastError("please Input Confirm Password");
                                return;
                            }
                        } else {
                            this.util.toastError("Please Input Password ");
                            return;
                        }
                    } else {
                        this.util.toastError("Please Input Email");
                        return;
                    }
                } else {
                    this.util.toastError("Please Input Mobile Number");
                    return;
                }
       
    }
    // Function to save an object to localStorage
    saveObjectToLocalStorage(key: string, data: any): void {
        localStorage.setItem(key, JSON.stringify(data));
    }

    // Function to retrieve an object from localStorage
    getObjectFromLocalStorage(key: string): any {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    }
    onLoggedin(user: SignUpRequest) {
        var req = new LoginRequest();
        req.username = user.username;
        req.password = window.btoa(user.password);
        //            req.password = (user.password);
        //            if (user.password === "12345678") {
        //                req.password = window.btoa(user.password);
        //            } else {
        //                req.password = (user.password);
        //            }
        //            //                        req.password = user.password;
        //            user.password = user.password;
        //            if (user.password === "12345678") {
        //                user.password = window.btoa(user.password);
        //                console.log(user.password);
        //            } else {
        //                user.password = (user.password);
        //                console.log(user.password);
        //            }
        //        
        console.log("Login Requestttttttttttttttttttttttttttttt");
        console.log(req)
        this.provider.doLogin(req).subscribe((data: any) => {
            console.log(data);
            if (data.message == "Password is wrong") {
                console.log("wrong password");
                this.util.toastError("Error, Entered Wrong Password")
            } else {
                console.log(data);
                localStorage.setItem('isLoggedin', 'true');
                var userSession: User = {
                    uid: data.username,
                    email: data.username,
                    User_Role: data.roles[0],
                    id_mongo: data.id,
                    token: data.accessToken,
                    token_Type: data.tokenType,
                    ORG_ID: data.org_id,
                    OPR_ID: data.opr_id,
                    CR_BY: data.cr_by,
                    MD_DT: data.md_dt,
                    CR_DT: data.cr_dt,
                    MD_BY: data.md_by,
                    app_role_id: data.app_role_id,
                    userType: data.userType,
                    isExpire: data.isExpire,
                    remainingDays: data.remainingDays,

                }
                this.auth.setUserDataToSessionNew(userSession);
                this.loading = this.util.hideLoading();
                this.dialogRef.close();
                this.isLoading = false;
                this.router.navigate(['/login']);
            }
        }, error => {
            this.util.toastError(error.error.error)
            console.log(error);
            this.loading = this.util.hideLoading();
        })

        console.log(localStorage);
    }
    public onNewClickedAction(event?: any) {
        throw new Error("Method not implemented.");
    }
    public onNewSaveAction(event?: any) {
      
    }
    public onModifyClickedAction(event?: any) {
        throw new Error("Method not implemented.");
    }
    public onUpdateSaveAction(event?: any) {
        throw new Error("Method not implemented.");
    }
    public onRemoveClickedAction(event?: any) {
        throw new Error("Method not implemented.");
    }
    public onDeleteSaveAction(event?: any) {
        throw new Error("Method not implemented.");
    }
    public onViewClickedAction(event?: any) {
        throw new Error("Method not implemented.");
    }
    public onUploadClickedAction(event?: any) {
        throw new Error("Method not implemented.");
    }
    public formSaveMode() {
        throw new Error("Method not implemented.");
    }
    public formUpdateMode() {
        throw new Error("Method not implemented.");
    }
    public formDeleteMode() {
        throw new Error("Method not implemented.");
    }
    public formViewMode() {
        throw new Error("Method not implemented.");
    }

    //        if (this.registration.gstNo != undefined) {
    //
    ////            this.getGSTDetails();
    ////            this.showDetails = true;
    //        }
    formListMod() {
        throw new Error("Method not implemented.");
    }
    //    27BHKPS7394K1ZC
}
